'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

var _logger = require('common/logger');

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * PaymentFormContainer
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This component is designed to extract the logic of the Payment Form from the representation, making
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * other varieties of payment forms more possible / extensible. This is somewhat of a new approach, and
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * is missing support for coupons or enterprise checkout at the moment.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * To use, wrap around a child component with your form itself and connect up the handlers via props.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * See InlineStripeForm for an example, and see the props provided in render() below for what you need
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * to implement.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var MININUM_CREDIT_CARD_LENGTH = 15;

var PaymentFormContainer = function (_Component) {
    _inherits(PaymentFormContainer, _Component);

    function PaymentFormContainer() {
        _classCallCheck(this, PaymentFormContainer);

        var _this = _possibleConstructorReturn(this, (PaymentFormContainer.__proto__ || Object.getPrototypeOf(PaymentFormContainer)).call(this));

        _this.onCardholderNameChange = function (e) {
            var card = _this.state.card;
            card.name = e.target.value;
            _this.setState({ card: card });
        };

        _this.onCardType = function (e) {
            var card = _this.state.card;
            var value = e.target.value;
            card.type = Stripe.cardType(value);
            card.number = value;
            _this.setState({ card: card });
        };

        _this.onExpMonthChange = function (e) {
            var card = _this.state.card;
            card.expMonth = e.target.value;
            _this.setState({ card: card });
        };

        _this.onExpYearChange = function (e) {
            var card = _this.state.card;
            card.expYear = e.target.value;
            _this.setState({ card: card });
        };

        _this.onCvvChange = function (e) {
            var card = _this.state.card;
            card.cvv = e.target.value;
            _this.setState({ card: card });
        };

        _this.onZipChange = function (e) {
            var card = _this.state.card;
            card.zip = e.target.value;
            _this.setState({ card: card });
        };

        _this.cardIsValid = function () {

            var valid = true;
            var card = _this.state.card;

            var cardErrors = {};
            if (!_this.cardNumberIsValid()) {
                cardErrors.number = 'Please enter a valid credit card number';
            }

            if (!card.name) {
                cardErrors.name = 'Please enter a valid name';
            }

            if (!card.cvv) {
                cardErrors.cvv = 'Please enter a valid security code';
            }

            if (!card.zip) {
                cardErrors.zip = 'Please enter a valid post code';
            }

            valid = Object.keys(cardErrors).length === 0;

            if (!valid) {
                var errors = _this.state.errors || {};
                errors.card = cardErrors;
                _this.setState({ errors: errors });
            }

            return valid;
        };

        _this.cardNumberIsValid = function () {
            var number = _this.numbersOnly(_this.state.card.number);

            if (typeof number !== 'string' || number.length < MININUM_CREDIT_CARD_LENGTH) {
                return false;
            }

            return true;
        };

        _this.numbersOnly = function (string) {
            return string.replace(/[^0-9]/g, '');
        };

        _this.onStart = function (e) {
            e.preventDefault();
            _this.initializeErrors();

            if (!_this.cardIsValid()) return;

            var card = _this.state.card;
            var cardNumber = _this.numbersOnly(card.number);
            var dataForStripe = {
                'number': cardNumber,
                'cvc': card.cvv,
                'exp_month': card.expMonth,
                'exp_year': card.expYear,
                'address_zip': card.zip,
                'name': card.name
            };

            if (_this.state.isProcessing == false) {

                _this.setState({
                    isProcessing: true
                });

                var self = _this;
                Stripe.card.createToken(dataForStripe, function (status, response) {
                    if (response.error) {

                        self.setGlobalError(response.error.message);
                    } else {
                        var token = response.id;
                        self.setState({
                            stripeToken: token
                        });
                        _logger2['default'].track('PaymentPage._onSuccess');
                        self.submitForm();
                    }
                });
            }
        };

        _this.submitForm = function () {

            var paymentForm = _this.props.paymentForm;
            var csrfToken = paymentForm.values._csrf_token;

            var card = _this.state.card;
            var cardNumber = _this.numbersOnly(card.number);
            var stripeToken = _this.state.stripeToken;

            var formData = {
                'payment[_csrf_token]': csrfToken,
                'payment[stripe_token]': stripeToken,
                'payment[cc_name]': card.name,
                'payment[cc_number]': cardNumber,
                'payment[cc_exp_month]': card.expMonth,
                'payment[cc_exp_year]': card.expYear,
                'payment[cc_zip]': card.zip,
                'payment[cc_security_code]': card.cvv,
                'payment[target_plan]': _this.props.targetPlan,
                'payment[period]': _this.props.period

            };

            var url = _this.props.formActionUrl || window.location.pathname;

            _superagent2['default'].post(url).type('form').send(formData).end(function (err, res) {

                if (err) {
                    _this.setGlobalError();
                    return;
                }

                var response = JSON.parse(res.text);
                if (response.success != true) {
                    _this.setGlobalError();
                    return;
                }

                _this.onSuccess(response);
            });
        };

        _this.onSuccess = function (response) {
            if (_this.props.onSuccess) {
                _this.props.onSuccess(response);
                _this.setState({
                    isProcessing: false
                });
            } else {
                // No need to set state as we're redirecting
                window.location = response.redirect_url;
            }
        };

        _this.setGlobalError = function (message) {
            var isProcessing = false;
            var errors = _this.state.errors;
            errors.global = message || 'There was an issue with your request.';
            _this.setState({ errors: errors, isProcessing: isProcessing });
        };

        _this.initializeErrors = function () {
            var errors = PaymentFormContainer.initialErrorState;
            _this.setState({ errors: errors });
        };

        _this.state = {
            card: {
                name: '',
                number: '',
                type: '',
                expMonth: '01',
                expYear: new Date().getFullYear() + 1,
                cvv: '',
                zip: ''
            },
            stripeToken: '',
            isProcessing: false,
            errors: PaymentFormContainer.initialErrorState
        };
        return _this;
    }

    _createClass(PaymentFormContainer, [{
        key: 'render',
        value: function render() {

            var props = {
                // Data
                card: this.state.card,
                // States
                errors: this.state.errors,
                isProcessing: this.state.isProcessing,
                // Functions
                onCardholderNameChange: this.onCardholderNameChange,
                onCardNumberChange: this.onCardType,
                onExpMonthChange: this.onExpMonthChange,
                onExpYearChange: this.onExpYearChange,
                onCvvChange: this.onCvvChange,
                onZipChange: this.onZipChange,
                onStart: this.onStart
            };

            var childrenWithProps = _react2['default'].Children.map(this.props.children, function (child) {
                return _react2['default'].cloneElement(child, props);
            });

            return _react2['default'].createElement(
                'div',
                null,
                childrenWithProps
            );
        }
    }]);

    return PaymentFormContainer;
}(_react.Component);

PaymentFormContainer.propTypes = {
    // Standard Symfony PaymentForm
    paymentForm: _react.PropTypes.object.isRequired,
    // (optional) Endpoint for post
    formActionUrl: _react.PropTypes.string,
    // Y or M
    period: _react.PropTypes.string
};
PaymentFormContainer.initialErrorState = {
    card: {},
    global: ''
};
exports['default'] = PaymentFormContainer;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/payment-page/payment-form-container.jsx
 ** module id = 1117
 ** module chunks = 0
 **/